import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Grow from '@material-ui/core/Grow'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import MenuItem from '@material-ui/core/MenuItem'
import MenuList from '@material-ui/core/MenuList'
import Paper from '@material-ui/core/Paper'
import Popper from '@material-ui/core/Popper'

import React, { useContext } from 'react'
import { useHistory } from 'react-router'
import { UserContext } from '../context api/UserContext'
import { toastMessage } from '../shared/AlertPopup'
import { ROUTES, success } from '../shared/constants'
import CustomLabel from './CustomLabel'

export default function CustomAvatar({ className }) {
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)
  const history = useHistory()
  const user = useContext(UserContext)
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const handleLogout = () => {
    localStorage.clear()
    history.push(ROUTES.HOME)
    return toastMessage('Logged Out Successfully...!', success)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  return (
    <div>
      <Box display="flex" ref={anchorRef} onClick={handleToggle} style={{ cursor: 'pointer' }}>
        {/* <Avatar src={user && user.user.profilePicture} /> */}
        <Avatar src={user && user.user.name} />
      </Box>

      <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
